<app-menu-bar-mobile></app-menu-bar-mobile>
<div class="dashboard">
  <div class="dashboard__header dashboard__header--main">
    <h1 class="title_42" [class.header_title]="!isBusiness">{{ "MENU.DASHBOARD" | translate }}</h1>
    <div class="dashboard__buttons" [class.dashboard__buttons-block]="bcFilterYear > 0">
      <!--            <div class="dashboard__buttons-filter hidden-xs" *ngIf="!isBusiness && !isTaxAdviser">-->
      <!--                <button class="btn&#45;&#45;dashboard-filter" [class.active]="viewType === viewTypeEnum.List" (click)="changeToListView()">-->
      <!--                    <img src="../../../assets/svg/dashboard_list.svg" alt="List">-->
      <!--                </button>-->
      <!--                <button class="btn&#45;&#45;dashboard-filter" [class.active]="viewType === viewTypeEnum.Card" (click)="changeToCardView()">-->
      <!--                    <img src="../../../assets/svg/dashboard_tiles.svg" alt="Tiles">-->
      <!--                 </button>-->
      <!--            </div>-->

      <!-- <div class="sort-wrap-btn" [class.hidden-xs]="!isBusiness">
<app-sort-list [batches]="batches" [statements]="paginatedStatementsList" [isBusiness]="isBusiness"
  [labelList]="labelList" [(filterButtonDisabled)]="filterButtonDisabled"
(filterEvent)="filter($event)"></app-sort-list>
</div> -->
      @if (bcFilterYear > 0 && !isBusiness && !isTaxAdviser) {
        <div class="sort-wrap-btn">
          <button class="btn_simple green" (click)="showAllStatements()">
            {{ "NEW_STATEMENT.DASHBOARD_SHOW_ALL" | translate }}
          </button>
        </div>
      }
      @if (bcFilterYear > 0) {
        <button
          class="btn_simple green"
          (click)="createStatementManually()"
          [class.large_btn_xs]="!isBusiness && !isTaxAdviser"
          [attr.data-cy]="'btnCreateStatement'"
        >
          {{ "DASHBOARD.FILE_NEW" | translate }}
        </button>
      }
      @if (bcFilterYear === 0) {
        @if (isBusiness || isTaxAdviser) {
          <app-sort-list
            [batches]="batches"
            [statements]="paginatedStatementsList"
            [isBusiness]="isBusiness || isTaxAdviser ? true : false"
            [labelList]="labelList"
            [(filterButtonDisabled)]="filterButtonDisabled"
            (filterEvent)="filter($event)"
            [isTaxAdviser]="isTaxAdviser ? true : false"
          ></app-sort-list>
        }
        <button
          class="btn_simple green"
          [class.large_btn_xs]="!isBusiness"
          (click)="newStatement()"
          [attr.data-cy]="'btnCreateStatement'"
        >
          {{ "DASHBOARD.FILE_NEW" | translate }}
        </button>
      }
    </div>
  </div>
  @if (!isBusiness && !isTaxAdviser) {
    <div
      class="dashboard-individual"
      [class.dashboard__content--card-view]="viewType === viewTypeEnum.Card"
      [class.dashboard-individual__list]="viewType === viewTypeEnum.List"
    >
      <div class="dashboard-individual__wrapper">
        @if (statementInProgressWarning && showStatementInProggressWarning) {
          <div class="alert_box" role="alert">
            <p [innerHTML]="'DASHBOARD.WARNING' | translate"></p>
            <div class="close_btn_wrap">
              <button
                class="close_btn"
                mat-icon-button
                aria-label="close"
                (click)="showStatementInProggressWarning = false"
              >
                <mat-icon aria-hidden="true">close</mat-icon>
              </button>
            </div>
          </div>
        }
        @if (statementsWithOpenDocumentRequest.length > 0) {
          <div class="dashboard-document-request">
            @for (statement of statementsWithOpenDocumentRequest; track statement.id) {
              <div class="dashboard-document-request__item">
                <div class="dashboard-document-request__banner">
                  <div class="dashboard-document-request__left">
                    <div class="dashboard-document-request__title">
                      <span class="dashboard-document-request__year">{{ statement.fullYear }}</span>
                      <span>{{ "DOCUMENT_REQUEST.BANNER_TAG" | translate }}</span>
                    </div>
                    <p>{{ "DOCUMENT_REQUEST.BANNER_MESSAGE" | translate }}</p>
                  </div>
                  <button class="btn_arrow dashboard-document-request__button" (click)="openDocumentRequestDialog(statement)">
                    {{ "DOCUMENT_REQUEST.BANNER_BUTTON" | translate }}
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                      <rect class="a" />
                      <path
                        class="b"
                        d="M25.525,21.439l-7.262-7.262a1.735,1.735,0,1,0-2.454,2.454L20.1,20.943H4.235a1.735,1.735,0,1,0,0,3.47H20.1L15.809,28.7a1.744,1.744,0,1,0,2.478,2.454l7.237-7.237a1.764,1.764,0,0,0,.52-1.239A1.666,1.666,0,0,0,25.525,21.439Z"
                        transform="translate(1.5 -6.675)"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            }
          </div>
        }
        <!-- TOP LIST OF STATEMENTS -->
        @if (!isBusiness && !isTaxAdviser) {
          <div class="dashboard__single_info_cont">
            @for (statement of unfinishedStatements; track statement) {
              <div class="dashboard__single_info_tile">
                <div class="dashboard__single_info_tile_wrap">
                  <div class="dashboard__single_info_tile_left">
                    <div class="dashboard__single_info_tile_head">
                      <span class="green">{{ statement.fullYear }}</span>
                      <span>{{ statement.lastName }} {{ statement.firstName }}</span>
                      <button (click)="expandUnfinishedStatements(statement)" class="visible-xs" mat-icon-button>
                        @if (!statement.isOpenDesc) {
                          <mat-icon>expand_more</mat-icon>
                        }
                        @if (statement.isOpenDesc) {
                          <mat-icon>expand_less</mat-icon>
                        }
                      </button>
                    </div>
                    @if (statement.serviceType === packageOptions.tax_adviser) {
                      <div class="dashboard__single_info_tile_desc" [class.active]="statement.isOpenDesc">
                        @if (statement.request_new_price_acceptance && !statement.isForClientApproval) {
                          {{ "DASHBOARD.SERVICE_TILES.ACCEPT_NEW_PRICE.DESC" | translate }}
                        } @else {
                          @if (statement.vollmachtSigned && statement.status !== statementStatuses.CLIENT_APPROVAL) {
                            {{ "DASHBOARD.SERVICE_TILES.TAX_ADVISER.VOLMACHT" | translate }}
                          }
                          @if (!statement.vollmachtSigned && statement.status !== statementStatuses.CLIENT_APPROVAL) {
                            {{ "DASHBOARD.SERVICE_TILES.TAX_ADVISER.NO_VOLMACHT" | translate }}
                          }
                          @if (statement.status === statementStatuses.CLIENT_APPROVAL) {
                            {{ "DASHBOARD.SERVICE_TILES.TAX_ADVISER.FOR_CLIENT_APPROVAL.DESC" | translate }}
                          }
                        }
                      </div>
                    }
                    @if (statement.serviceType === "paid_service" && statement.status === "paid") {
                      <div class="dashboard__single_info_tile_desc 2" [class.active]="statement.isOpenDesc">
                        {{ "DASHBOARD.SERVICE_TILES.PAID_SERVICE.DESC" | translate }}
                      </div>
                    }
                  </div>
                  <div class="dashboard__single_info_tile_right">
                    @if (statement.serviceType === packageOptions.tax_adviser) {
                      @if (statement.request_new_price_acceptance && !statement.isForClientApproval) {
                        <button class="btn_arrow" (click)="goToConfirmNewPrice(statement)">
                          {{ "DASHBOARD.SERVICE_TILES.ACCEPT_NEW_PRICE.BUTTON" | translate }}
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                            <rect class="a" />
                            <path
                              class="b"
                              d="M25.525,21.439l-7.262-7.262a1.735,1.735,0,1,0-2.454,2.454L20.1,20.943H4.235a1.735,1.735,0,1,0,0,3.47H20.1L15.809,28.7a1.744,1.744,0,1,0,2.478,2.454l7.237-7.237a1.764,1.764,0,0,0,.52-1.239A1.666,1.666,0,0,0,25.525,21.439Z"
                              transform="translate(1.5 -6.675)"
                            />
                          </svg>
                        </button>
                      }
                      @if (statement.serviceType === "tax_adviser") {
                        @if (statement.vollmachtSigned && statement.hasVerifiedIdentity === null) {
                          <button class="btn_arrow" (click)="goToIdentityVerification(statement)">
                            {{ "DASHBOARD.SERVICE_TILES.TAX_ADVISER.VOLMACHT_BUTTON" | translate }}
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                              <rect class="a" />
                              <path
                                class="b"
                                d="M25.525,21.439l-7.262-7.262a1.735,1.735,0,1,0-2.454,2.454L20.1,20.943H4.235a1.735,1.735,0,1,0,0,3.47H20.1L15.809,28.7a1.744,1.744,0,1,0,2.478,2.454l7.237-7.237a1.764,1.764,0,0,0,.52-1.239A1.666,1.666,0,0,0,25.525,21.439Z"
                                transform="translate(1.5 -6.675)"
                              />
                            </svg>
                          </button>
                        }
                        @if (statement.vollmachtSigned && statement.hasVerifiedIdentity === false) {
                          <button class="btn_arrow" (click)="goToIdentityVerification(statement)">
                            {{ "DASHBOARD.SERVICE_TILES.TAX_ADVISER.VOLMACHT_BUTTON_VERIFY_AGAIN" | translate }}
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                              <rect class="a" />
                              <path
                                class="b"
                                d="M25.525,21.439l-7.262-7.262a1.735,1.735,0,1,0-2.454,2.454L20.1,20.943H4.235a1.735,1.735,0,1,0,0,3.47H20.1L15.809,28.7a1.744,1.744,0,1,0,2.478,2.454l7.237-7.237a1.764,1.764,0,0,0,.52-1.239A1.666,1.666,0,0,0,25.525,21.439Z"
                                transform="translate(1.5 -6.675)"
                              />
                            </svg>
                          </button>
                        }
                      }
                      @if (!statement.vollmachtSigned && statement.status !== statementStatuses.CLIENT_APPROVAL) {
                        <button class="btn_arrow" (click)="goToVolmacht(statement)">
                          {{ "DASHBOARD.SERVICE_TILES.TAX_ADVISER.NO_VOLMACHT_BUTTON" | translate }}
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                            <rect class="a" />
                            <path
                              class="b"
                              d="M25.525,21.439l-7.262-7.262a1.735,1.735,0,1,0-2.454,2.454L20.1,20.943H4.235a1.735,1.735,0,1,0,0,3.47H20.1L15.809,28.7a1.744,1.744,0,1,0,2.478,2.454l7.237-7.237a1.764,1.764,0,0,0,.52-1.239A1.666,1.666,0,0,0,25.525,21.439Z"
                              transform="translate(1.5 -6.675)"
                            />
                          </svg>
                        </button>
                      }
                      @if (statement.isForClientApproval) {
                        <button class="btn_arrow" (click)="goToConfirmTaxReturn(statement)">
                          {{ "DASHBOARD.SERVICE_TILES.TAX_ADVISER.FOR_CLIENT_APPROVAL.BUTTON" | translate }}
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                            <rect class="a" />
                            <path
                              class="b"
                              d="M25.525,21.439l-7.262-7.262a1.735,1.735,0,1,0-2.454,2.454L20.1,20.943H4.235a1.735,1.735,0,1,0,0,3.47H20.1L15.809,28.7a1.744,1.744,0,1,0,2.478,2.454l7.237-7.237a1.764,1.764,0,0,0,.52-1.239A1.666,1.666,0,0,0,25.525,21.439Z"
                              transform="translate(1.5 -6.675)"
                            />
                          </svg>
                        </button>
                      }
                    }
                    @if (statement.serviceType === packageOptions.paid && statement.status === "paid") {
                      <button class="btn_arrow qwe" (click)="goToTaxCard(statement)">
                        {{ "DASHBOARD.SERVICE_TILES.PAID_SERVICE.BUTTON" | translate }}
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                          <rect class="a" />
                          <path
                            class="b"
                            d="M25.525,21.439l-7.262-7.262a1.735,1.735,0,1,0-2.454,2.454L20.1,20.943H4.235a1.735,1.735,0,1,0,0,3.47H20.1L15.809,28.7a1.744,1.744,0,1,0,2.478,2.454l7.237-7.237a1.764,1.764,0,0,0,.52-1.239A1.666,1.666,0,0,0,25.525,21.439Z"
                            transform="translate(1.5 -6.675)"
                          />
                        </svg>
                      </button>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        }
        @if (viewType === viewTypeEnum.List) {
          <div class="dashboard__header">
            <h2 class="dashboard__title dashboard__title--small title"
              >{{ "COMMON.TAX_RETURN" | translate }}
              @if (bcFilterYear > 0) {
                {{ "NEW_STATEMENT.DASHBOARD_YEAR" | translate }} {{ bcFilterYear }}
              }
            </h2>
          </div>
        }
        <!-- <ng-container *ngIf="bcFilterYear>0">
      <div class="new-deductions-info is_icon">
        <div class="new-deductions-info__wrap">
          <div class="new-deductions-info__toltip-wrap">
            <img src="../../../assets/svg/infoMark.svg" class="alert_icon">
          </div>
          <div class="new-deductions-info__wrap-text">
            <span class="new-deductions-info__text">
              {{'NEW_STATEMENT.DASHBOARD_INFO' | translate}}
            </span>
          </div>
        </div>
      </div>
    </ng-container> -->
        @if (viewType === viewTypeEnum.Card) {
          <app-card-view
            [statements]="paginatedStatementsList"
            (downloadPdf)="downloadPdf($event)"
            (downloadInvoice)="downloadInvoice($event)"
            (showDownloadDialog)="showDownloadDialog($event)"
            (deleteStatement)="deleteStatement($event)"
            (cloneStatement)="cloneStatement($event)"
            [(yearsList)]="yearsList"
          >
          </app-card-view>
        }
        <div class="dashboard__list">
          @if (viewType === viewTypeEnum.List) {
            <app-list-view
              [statements]="paginatedStatementsList"
              (downloadPdf)="downloadPdf($event)"
              (downloadInvoice)="downloadInvoice($event)"
              (showDownloadDialog)="showDownloadDialog($event)"
              (deleteStatement)="deleteStatement($event)"
              (cloneStatement)="cloneStatement($event)"
            >
            </app-list-view>
          }
        </div>
      </div>
      <app-paginator [pageCount]="pageCount" [currentPage]="page" (changePage)="changePage($event)"></app-paginator>
    </div>
  }

  @if (isBusiness && !isTaxAdviser) {
    <div class="dashboard-business">
      @if (batches && batches.length) {
        <div class="dashboard-business__list">
          @for (batch of batches; track batch; let i = $index) {
            <div class="dashboard-business__batch">
              <div>
                <div class="dashboard-business__batch-text">
                  <span>{{ "COMMON.BATCH_FILE" | translate }}</span>
                  <div class="dashboard-business__buttons">
                    @if (!hideEditButton(i)) {
                      <button
                        class="btn btn--info btn--small"
                        (click)="editBatch(i)"
                        [id]="'batch_edit_' + i"
                        [attr.data-cy]="'btnEditStatementBatch_' + i"
                      >
                        {{ "COMMON.EDIT_BATCH" | translate }}
                      </button>
                    }
                    @if (!hideRemoveButton(i)) {
                      <button
                        class="btn btn--info btn--small"
                        [disabled]="batchRemoving"
                        (click)="removeBatch(i)"
                        [attr.data-cy]="'btnRemoveStatementBatch_' + i"
                      >
                        {{ "COMMON.REMOVE_BATCH" | translate }}
                      </button>
                    }
                    @if (!hideRemoveButton(i)) {
                      <span class="ico-remove" (click)="removeBatch(i)"><i class="fa fa-trash"></i></span>
                    }
                  </div>
                </div>
                <div class="dashboard-business__batch-content">
                  <app-accordion [title]="batch.code" [titleFrame]="true" [transparentBg]="true" [noPadding]="true">
                    <app-list-view-b2b
                      [statements]="batch.statements"
                      (deleteStatement)="deleteBatchStatement($event, i)"
                      (cloneStatement)="cloneStatement($event)"
                      [hideEditing]="true"
                      [hideInvoice]="true"
                      [labelList]="labelList"
                    ></app-list-view-b2b>
                    @if (!batch?.statements?.length) {
                      <div class="dashboard-business__batch-empty"> {{ "COMMON.BATCH_EMPTY" | translate }}</div>
                    }
                  </app-accordion>
                </div>
              </div>
            </div>
          }
        </div>
      }
      <app-paginator [pageCount]="pageCount" [currentPage]="page" (changePage)="changePage($event)"></app-paginator>
    </div>
  }

  @if (isTaxAdviser) {
    <div class="dashboard-business">
      @if (paginatedStatementsList && paginatedStatementsList.length) {
        <div class="dashboard-business__list">
          @for (statement of paginatedStatementsList; track statement; let i = $index) {
            <div class="dashboard-business__batch">
              <div>
                <div class="dashboard-business__batch-text">
                  <span>{{ "COMMON.BATCH_FILE" | translate }}</span>
                  <div class="dashboard-business__buttons">
                    @if (!hideEditButtonTaxAdviser(i)) {
                      <button
                        class="btn btn--info btn--small"
                        (click)="editStatementTaxAdviser(i)"
                        [id]="'batch_edit_' + i"
                        [attr.data-cy]="'btnEditStatementBatch_' + i"
                      >
                        {{ "COMMON.EDIT_BATCH" | translate }}
                      </button>
                    }
                    @if (!hideRemoveButtonTaxAdviser(i)) {
                      <button
                        class="btn-remove"
                        [disabled]="batchRemoving"
                        (click)="removeBatchTaxAdviser(i)"
                        [attr.data-cy]="'btnRemoveStatementBatch_' + i"
                      >
                        {{ "COMMON.REMOVE_BATCH" | translate }}
                      </button>
                    }
                    @if (!hideRemoveButtonTaxAdviser(i)) {
                      <span class="ico-remove" (click)="removeBatchTaxAdviser(i)"><i class="fa fa-trash"></i></span>
                    }
                  </div>
                </div>
                <div class="dashboard-business__batch-content">
                  <app-accordion
                    [title]="paginatedStatementsList[i].emailAddress"
                    [titleFrame]="true"
                    [transparentBg]="true"
                    [noPadding]="true"
                  >
                    <app-list-view
                      [statements]="[paginatedStatementsList[i]]"
                      (downloadPdf)="downloadPdf($event)"
                      (showDownloadDialog)="showDownloadDialog($event)"
                      (deleteStatement)="deleteStatement($event, i)"
                      (cloneStatement)="cloneStatement($event)"
                      [hideEditing]="true"
                      [hideInvoice]="true"
                      [labelList]="labelList"
                    ></app-list-view>
                    @if (!paginatedStatementsList[i]) {
                      <div class="dashboard-business__batch-empty"> {{ "COMMON.BATCH_EMPTY" | translate }}</div>
                    }
                  </app-accordion>
                </div>
              </div>
            </div>
          }
        </div>
      }
      <app-paginator [pageCount]="pageCount" [currentPage]="page" (changePage)="changePage($event)"></app-paginator>
    </div>
  }
</div>
